export interface ReleaseDateError {
  releaseDate?: string
}

export function formatErrorMessage (
  rawMessage: string | object | undefined,
  fallback: string
): string {
  if (typeof rawMessage === 'object' && rawMessage !== null) {
    const err = rawMessage as ReleaseDateError
    return err.releaseDate ?? fallback
  }
  return (rawMessage as string) || fallback
}
